import React from "react";
import classnames from "classnames";

const renderInputField = ({input, label, type, placeholder, height = 47, maxLength, countAtBottom, count, hideMaxLength, min, max, meta: {touched, error, warning, initial}}) => {
    const countAtBottomClass = classnames("custom-form-input-character-count", {
        "custom-form-input-character-count-bottom": countAtBottom
    })
    return (
        <div className="form-group">
            {
                (label.length > 0) && < label className="label-14"> {label}</label>
            }

            <div className="input-group" style={{height: height}}>
                <input className="form-control custom-form-input"
                       {...input}
                       placeholder={placeholder}
                       maxLength={maxLength}
                       type={type}/>

                <div className={countAtBottomClass}>
                    <span>{count}</span>/{maxLength} characters
                </div>
            </div>


            {touched &&
            ((error && <span className="custom-form-text-danger">{error}</span>) ||
                (warning && <span className="text-warning">{warning}</span>))}
        </div>
    )
};


const renderTextAreaField = ({input, height, label, placeholder, count, minLength = 10, countAtBottom, maxLength = 280, meta: {touched, error, warning}}) => {
    const countAtBottomClass = classnames("custom-form-input-character-count", {
        "custom-form-input-character-count-bottom": countAtBottom
    })
    return (
        <div className="form-group">
            {
                (label.length > 0) && <label className="label-14"> {label}</label>
            }

            <div className="input-group" style={{height: height}}>
            <textarea className="form-control custom-form-input custom-form-input-textarea"
                      {...input}
                      placeholder={placeholder}
                      maxLength={maxLength}
                      style={{height: height}}>

            </textarea>

                <div className={countAtBottomClass}>
                    <span>{count}</span>/{maxLength} characters
                </div>
            </div>


            {touched &&
            ((error && <span className="custom-form-text-danger">{error}</span>) ||
                (warning && <span className="text-warning">{warning}</span>))}
        </div>
    )

};

const renderRadioField = ({input,checked,disabled ,label, meta: {touched, error, warning}}) => (
    <div className="form-group">
        <label className="custom-radio-btn-container">{label}
            <input type="radio"  {...input} checked={checked} disabled={disabled} name="radio"/>
            <span className="checkmark"></span>
        </label>

        {touched &&
        ((error && <span className="custom-form-text-danger">{error}</span>) ||
            (warning && <span className="text-warning">{warning}</span>))}
    </div>
);

const renderCheckBoxField = ({input,checked,disabled ,label, meta: {touched, error, warning}}) => (
    <div className="form-group">
        <label className="custom-checkbox-container">{label}
            <input type="checkbox"  {...input} checked={checked} disabled={disabled}/>
                <span className="checkmark"></span>
        </label>

        {touched &&
        ((error && <span className="custom-form-text-danger">{error}</span>) ||
            (warning && <span className="text-warning">{warning}</span>))}
    </div>
);

export default {
    renderInputField,
    renderTextAreaField,
    renderRadioField,
    renderCheckBoxField
}